import { Plugin, TextSelection, PluginKey, } from "prosemirror-state";
import { Decoration, DecorationSet } from "prosemirror-view";
const placeholderPluginKey = new PluginKey("placeholder");
export function Placeholder({ placeholder, tip, placeholderMode, }) {
    let view = null;
    return new Plugin({
        key: placeholderPluginKey,
        view: (editorView) => {
            view = editorView;
            return {};
        },
        props: {
            decorations: (state) => {
                if (!(view === null || view === void 0 ? void 0 : view.editable)) {
                    return null;
                }
                if (!(state.selection instanceof TextSelection)) {
                    return null;
                }
                if (!state.selection.$cursor) {
                    return null;
                }
                const cursor = state.selection.$cursor;
                const node = state.selection.$cursor.node();
                if (!shouldIncludePlaceholderForNodeType(node.type.name)) {
                    return null;
                }
                if (!node.type.isBlock || node.childCount !== 0) {
                    // node is not empty
                    return null;
                }
                const decoration = DecorationSet.create(state.doc, [
                    Decoration.node(cursor.pos - 1, cursor.pos + node.nodeSize - 1, {
                        class: "empty-node",
                        "data-placeholder": placeholder,
                        "data-tip": tip || "",
                        "data-show-placeholder": String(placeholderMode === "tip-or-empty-doc"
                            ? state.doc.childCount <= 1
                            : true),
                    }),
                ]);
                if (placeholderMode === "empty-node" ||
                    placeholderMode === "tip-or-empty-doc") {
                    return decoration;
                }
                if (placeholderMode === "empty-doc" && state.doc.childCount <= 1) {
                    return decoration;
                }
            },
        },
    });
}
function shouldIncludePlaceholderForNodeType(nodeType) {
    return ["paragraph", "paragraph_small", "heading"].includes(nodeType);
}
